import React, { FC } from "react";

interface Props {
  dayOfMonth: number;
  date?: Date | undefined;
  unavailableDates?: Date[];
  partiallyUnavailable?: boolean;
  partialTimes?: { from: string; to: string }[];
}

const DatePickerCustomDay: FC<Props> = ({
  dayOfMonth,
  date,
  unavailableDates = [],
  partiallyUnavailable = false,
  partialTimes = [],
}) => {
  const isUnavailable = date
    ? unavailableDates.some(
        (unavailableDate) =>
          unavailableDate.toDateString() === date.toDateString()
      )
    : false;

  return (
    <span
      className={`react-datepicker__day_span flex flex-col items-center ${
        isUnavailable ? "line-through" : ""
      }`}
    >
      <span>{dayOfMonth}</span>
      <div
        className="w-6 h-1 rounded border-[0.5px] border-gray-300"
        style={{
          background: isUnavailable
            ? "red"
            : partiallyUnavailable
            ? "linear-gradient(to right, red 50%, green 50%)"
            : "green",
        }}
      />
      {/* {!isUnavailable && partiallyUnavailable && partialTimes && (
      <span title={partialTimes.map((t) => `${t.from} - ${t.to}`).join(", ")}>
        ⚠️
      </span>
      )} */}
    </span>
  );
};

export default DatePickerCustomDay;